var _clipPath, _clipPath2, _clipPath3, _clipPath4, _linearGradient, _clipPath5, _radialGradient, _g, _path, _path2, _path3, _g2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlutter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    width: 64,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "flutter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "flutter_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "flutter_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "flutter_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "flutter_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 566.635,
    x2: 685.65,
    y1: 970.339,
    y2: 851.324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "flutter_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "flutter_svg__g",
    cx: 7824.659,
    cy: -2855.979,
    gradientTransform: "matrix(.25 0 0 -.25 -1812 -622.5)",
    gradientUnits: "userSpaceOnUse",
    r: 5082.889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flutter_svg__a)",
    transform: "matrix(.06162 0 0 .06162 -1.43 -1.275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.3 779.7L520 939.5 959.4 500H639.9z",
    fill: "#39cefd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#flutter_svg__b)",
    d: "M639.9 20.7h319.5l-679 679.1L120.6 540z",
    fill: "#39cefd",
    transform: "matrix(.06162 0 0 .06162 -1.43 -1.275)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#flutter_svg__c)",
    d: "M520 939.5l119.9 119.8h319.5L679.8 779.7z",
    fill: "#03569b",
    transform: "matrix(.06162 0 0 .06162 -1.43 -1.275)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#flutter_svg__d)",
    d: "M757 857.4l-77.2-77.7L520 939.5z",
    fill: "url(#flutter_svg__e)",
    transform: "matrix(.06162 0 0 .06162 -1.43 -1.275)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flutter_svg__f)",
    transform: "matrix(.06162 0 0 .06162 -1.43 -1.275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.282 779.645L520.086 619.84 679.9 779.645 520.086 939.45z",
    fill: "#16b9fd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z",
    fill: "url(#flutter_svg__g)",
    transform: "matrix(.06162 0 0 .06162 -1.43 -1.275)"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgFlutter as ReactComponent };